var map = {
	"./american-express.svg": "a491",
	"./bancontact.svg": "d422",
	"./belfius.svg": "eb2e",
	"./ideal.svg": "a066",
	"./ideal2.svg": "1092",
	"./ing-home-pay.svg": "9ef3",
	"./kbc-cbc.svg": "fa43",
	"./maestro.svg": "acd3",
	"./mastercard.svg": "ed9d",
	"./sepa.svg": "f81c",
	"./sofort.svg": "2823",
	"./visa.svg": "2a0d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "488c";